const GET_ADMIN_RECIPES_AND_VIDEOS_REQUEST = 'GET_ADMIN_RECIPES_AND_VIDEOS_REQUEST';
const GET_ADMIN_RECIPES_AND_VIDEOS_SUCCESS = 'GET_ADMIN_RECIPES_AND_VIDEOS_SUCCESS';
const GET_ADMIN_RECIPES_AND_VIDEOS_FAIL = 'GET_ADMIN_RECIPES_AND_VIDEOS_FAIL';

const CLEAR_RECIPE_UPLOAD_STATE = 'CLEAR_RECIPE_UPLOAD_STATE';

export {
  GET_ADMIN_RECIPES_AND_VIDEOS_REQUEST,
  GET_ADMIN_RECIPES_AND_VIDEOS_SUCCESS,
  GET_ADMIN_RECIPES_AND_VIDEOS_FAIL,
  CLEAR_RECIPE_UPLOAD_STATE
};